// extracted by mini-css-extract-plugin
export default {"form":"CustomShippingForm_form__8LuPJ","column":"CustomShippingForm_column__CXibz"};